/** @jsx dom */
import dom from 'magic-virtual-element';
import {utils as cmsUtils} from '@viskan/cms-components';

const render = ({props}) => {
	const {elementType, prefix, searchQuery, suffix, styleClasses} = props;

	const attributes = {
		innerHTML: `${prefix}${searchQuery}${suffix}`,
		'data-style-attr': 'SearchHeading',
		class: styleClasses.SearchHeading
	};

	return cmsUtils.createCmsComponent(dom(elementType, attributes), props);
};

export default {render};
